import { useContext } from 'react';

import Context from './Context';

const useLocale = () => {
  return useContext(Context);
};

export default useLocale;
